

// export const API_BASE_URL = "http://localhost:3001/api";
export const API_BASE_URL = "http://uatapi.i-sure.in:3000/api";
// export const API_BASE_URL = "http://www.uatapi.i-sure.in:3001/api";
// export const API_BASE_URL="http://localhost:3001/api"
